/**
 * moray-qa-sheet.js — Quick-add "+" de la product card (móvil, MORAY).
 * Contrato: cualquier [data-moray-qa="<handle>"] abre el flujo.
 *  - 1 sola variante disponible → añade directo (como iurop-quick-add).
 *  - Varias variantes (tallas) → bottom sheet selector (P5.2: prohibido
 *    añadir directo con tallas). Píldoras agotadas visibles, no seleccionables.
 * Tras añadir: POST /cart/add.js + cart:updated {detail:{cart}} → el drawer
 * de iurop-cart-drawer.js se abre solo. Ids de variante SIEMPRE string.
 * Sheet ÚNICO global creado por JS; delegación en document (sobrevive
 * re-renders). Cierre: X, backdrop, Esc.
 */
(function () {
  'use strict';
  if (window.__morayQaSheet) return;
  window.__morayQaSheet = true;

  var sheet = null;
  var current = null; // producto del sheet abierto
  var selectedId = null;

  function money(cents) {
    var lang = document.documentElement.lang || 'es';
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      });
  }

  function build() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'moray-qa';
    sheet.hidden = true; // [hidden] lleva el on/off real; .is-open solo la animacion
    sheet.innerHTML =
      '<div class="moray-qa__backdrop" data-qa-close></div>' +
      '<div class="moray-qa__panel" role="dialog" aria-modal="true" aria-label="Elige tu talla">' +
      '  <button type="button" class="moray-qa__close" data-qa-close aria-label="Cerrar">&times;</button>' +
      '  <div class="moray-qa__head">' +
      '    <span class="moray-qa__title" data-qa-title></span>' +
      '    <span class="moray-qa__price" data-qa-price></span>' +
      '  </div>' +
      '  <p class="moray-qa__label" data-qa-label></p>' +
      '  <div class="moray-qa__sizes" data-qa-sizes></div>' +
      '  <button type="button" class="moray-qa__add" data-qa-add disabled>AÑADIR AL CARRITO</button>' +
      '  <p class="moray-qa__error" data-qa-error hidden>No se pudo añadir. Inténtalo de nuevo.</p>' +
      '</div>';
    document.body.appendChild(sheet);
    return sheet;
  }

  function open(product) {
    build();
    current = product;
    selectedId = null;
    sheet.querySelector('[data-qa-title]').textContent = product.title;
    sheet.querySelector('[data-qa-price]').textContent = money(product.price);
    // product.options: OBJETOS {name, position, values} — nunca interpolar el objeto
    var optName = (product.options && product.options[0] && (product.options[0].name || product.options[0])) || 'Talla';
    sheet.querySelector('[data-qa-label]').textContent = optName;
    var wrap = sheet.querySelector('[data-qa-sizes]');
    wrap.innerHTML = '';
    product.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'moray-qa__size';
      b.textContent = v.title === 'Default Title' ? optName : v.title;
      b.dataset.qaVariant = String(v.id);
      if (!v.available) b.disabled = true;
      wrap.appendChild(b);
    });
    var add = sheet.querySelector('[data-qa-add]');
    add.disabled = true;
    add.classList.remove('is-loading');
    sheet.querySelector('[data-qa-error]').hidden = true;
    // Entrada animada: quitar [hidden], forzar reflow (para que el primer
    // frame pintado sea translateY(100%)) y ENTONCES abrir. Sin el reflow
    // el panel aparece ya en su sitio, sin deslizar.
    sheet.hidden = false;
    void sheet.offsetHeight;
    sheet.classList.add('is-open');
    document.documentElement.classList.add('moray-qa-lock');
  }

  function close() {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('moray-qa-lock');
    current = null;
    selectedId = null;
    // Salida simetrica a la entrada: el [hidden] se repone cuando ACABA la
    // transicion de transform del panel (mismo cubic-bezier del CSS), con
    // timeout de respaldo por si transitionend no llega (pestana oculta).
    var panel = sheet.querySelector('.moray-qa__panel');
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      // Guard: si se reabrio durante el cierre, no ocultar.
      if (sheet.classList.contains('is-open')) return;
      sheet.hidden = true;
    }
    var dur = (parseFloat(getComputedStyle(panel).transitionDuration) || 0) * 1000;
    if (!dur) { finish(); return; } // prefers-reduced-motion: sin transicion
    panel.addEventListener('transitionend', function onEnd(ev) {
      if (ev.target !== panel || ev.propertyName !== 'transform') return;
      panel.removeEventListener('transitionend', onEnd);
      finish();
    });
    setTimeout(finish, dur + 80);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-moray-qa]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      if (trigger.classList.contains('is-loading')) return;
      var handle = trigger.getAttribute('data-moray-qa');
      trigger.classList.add('is-loading');
      fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('product fetch'); return r.json(); })
        .then(function (product) {
          var avail = product.variants.filter(function (v) { return v.available; });
          if (avail.length === 1 && product.variants.length === 1) {
            // Variante única → añadir directo (sin tallas no hay selector que abrir)
            return addToCart(String(avail[0].id));
          }
          open(product);
        })
        .catch(function () {
          // Sin JS de producto → navegar a la ficha (nunca dejar el tap mudo)
          var link = trigger.closest('.iurop-product-card');
          var a = link && link.querySelector('a[href]');
          if (a) window.location.href = a.getAttribute('href');
        })
        .then(function () { trigger.classList.remove('is-loading'); });
      return;
    }

    if (!sheet || !sheet.classList.contains('is-open')) return;

    var size = e.target.closest('.moray-qa__size');
    if (size && sheet.contains(size) && !size.disabled) {
      sheet.querySelectorAll('.moray-qa__size').forEach(function (s) { s.classList.remove('is-selected'); });
      size.classList.add('is-selected');
      selectedId = size.dataset.qaVariant;
      sheet.querySelector('[data-qa-add]').disabled = false;
      return;
    }

    var add = e.target.closest('[data-qa-add]');
    if (add && !add.disabled && selectedId) {
      add.classList.add('is-loading');
      addToCart(selectedId)
        .then(function () { close(); })
        .catch(function () {
          sheet.querySelector('[data-qa-error]').hidden = false;
          add.classList.remove('is-loading');
        });
      return;
    }

    if (e.target.closest('[data-qa-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet && sheet.classList.contains('is-open')) close();
  });
})();
